import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { englishCrmMessages } from "./englishCrmMessages";
import { portugueseCrmMessages } from "./portugueseCrmMessages";
import {
  portugueseRaMessages,
  raSupabasePortugueseMessages,
} from "./portugueseRaMessages";

const raSupabaseEnglishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Check your emails for a Reset Password message.",
    },
  },
};

const englishCatalog = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  raSupabaseEnglishMessagesOverride,
  englishCrmMessages,
);

const portugueseCatalog = mergeTranslations(
  englishCatalog,
  portugueseRaMessages,
  raSupabasePortugueseMessages,
  portugueseCrmMessages,
);

export type CrmLocale = "en" | "pt-BR";

// Portuguese is the native language; English is opt-in via the language menu.
export const DEFAULT_LOCALE: CrmLocale = "pt-BR";

export const i18nProvider = polyglotI18nProvider(
  (locale) => (locale === "en" ? englishCatalog : portugueseCatalog),
  DEFAULT_LOCALE,
  [
    { locale: "pt-BR", name: "Português (Brasil)" },
    { locale: "en", name: "English" },
  ],
  { allowMissing: true },
);

export const testI18nProvider = polyglotI18nProvider(
  () => englishCatalog,
  "en",
  [{ locale: "en", name: "English" }],
  { allowMissing: true },
);
